import React from 'react';
import PropTypes from 'prop-types';
import TextField from 'material-ui/TextField';
import IconVideo from 'material-ui/svg-icons/av/videocam';
import IconImage from 'material-ui/svg-icons/editor/insert-photo';
import IconAttachment from 'material-ui/svg-icons/editor/attach-file';
import IconClear from 'material-ui/svg-icons/content/clear';
import _ from 'lodash'
import IconPrint from "material-ui/svg-icons/action/print";
import IconEdit from 'material-ui/svg-icons/editor/mode-edit';
import IconDelete from 'material-ui/svg-icons/action/delete-forever';
import Dialog from 'material-ui/Dialog';
import Title from '../../../components/common/Title';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import IconAdd from 'material-ui/svg-icons/content/add-circle-outline';
import ImagePicker from '../../../components/common/ImagePicker';
import VideoPicker from '../../../components/common/VideoPicker';
import colors from '../../../styles/colors'
import { Divider } from 'material-ui';
import '../../../resources/styles/instructions.css';

import FloatingActionButton from 'material-ui/FloatingActionButton';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import AutoComplete from 'material-ui/AutoComplete';
import UrlUtils from '../../utils/urlUtils';
import wistiaLogo from '../../../resources/images/wistia.png';
import youTubeLogo from '../../../resources/images/youTube.jpg';

import FilePicker from '../../../components/common/FilePicker';
import NormalFlatButton from '../../../components/common/NormalFlatButton';
import DeleteButton from '../../../components/common/DeleteButton';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { convertFromRaw, EditorState,convertToRaw } from 'draft-js';
import draftToMarkdown from 'draftjs-to-markdown';
import { mdToDraftjs, draftjsToMd } from 'draftjs-md-converter';
import { markdownToDraft } from 'markdown-draft-js';
import {stateToHTML} from 'draft-js-export-html';
import RichTextEditor from 'react-rte';
import {getTextAlignBlockMetadata, getTextAlignClassName, getTextAlignStyles} from './blockStyleFunctions';
import UUID from 'uuid/v4';

const style = {
  instructionHeader:{
    color: colors.primary,
    fontWeight:900,
    marginTop:0,
    marginBottom: 20,
  },
  content:{
    width: '90%',
    margin:'auto'
  },
  divider:{
    marginTop: '10px'
  },
  labelContainer:{
    maringBottom:10,
    alignItems:'center',
    display:'flex',
    flexWrap:'wrap',
  },
  label:{
    marginRight:5,
    color: colors.primary
  },
  name:{
    width: '100%',
    display: 'flex',
    flexCirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  print: {
    cursor: 'pointer',
    color: colors.primary
  },
  edit:{
    cursor:'pointer',
    color: colors.primary
  },
  delete:{
    cursor:'pointer',
    color: colors.primary
  },
  editDialog:{
    height:'50vh',
    overflowX:'hidden',
    paddingRight:'25px'
  },
  marginRight:{
    marginRight:'15px'
  },
  insLabel:{
    fontSize:'16px',
    color: colors.primary,
  }
};

class InstructionLibrary extends React.PureComponent {
  
  propTypes: {
    nodeText: PropTypes.string.isRequired,
    category: PropTypes.string.isRequired
  }

  constructor(props) {
    super(props);
    this.state = {
      editorState: RichTextEditor.createEmptyValue(),
      text: props.nodeText,
      category: props.category,
      categories: props.allCategories,
      openEdit: false,
      updateInst:'',
      attachments:{
        videoAdded: false,
        imageAdded: false,
      },
      searchText:'',
      updateEditor:0,
    };

  }

  componentWillReceiveProps(props) {
    this.setState({
      text: props.nodeText,
      category: props.category,
      groupName: props.groupName,
      searchText: props.groupName,
      attachments:{
        videoAdded: (props.category.videoUrl)?true: false,
        imageAdded: (props.category.imageUrl)?true: false,
      }
    });
  }

  handleClose = () => {
    this.setState({
      openEdit: false,
      updateInst:{...this.props.category},
      attachments:{
        videoAdded: (this.props.category.videoUrl)?true: false,
        imageAdded: (this.props.category.imageUrl)?true: false,
      }
    })
  };

  upadteInstruction = () => {
    if(!this.state.updateInst.categoryId){
      this.state.updateInst.categoryId=UUID();
    }

    this.setState({
      category: this.state.updateInst,
      openEdit: false,
    })
    let groupName = '';
    if( this.state.groupName === this.state.searchText){
      groupName = this.state.groupName
    }else if( this.state.groupName && this.state.groupName['textKey'] &&  this.state.groupName['textKey'] === this.state.searchText){
      groupName = this.state.groupName
    }else {
      groupName = this.state.searchText
    }

    //Set update time to library instruction
    this.state.updateInst.modifiedAt = { nanos: 0, seconds: new Date().getTime()};

    this.props.updateInstruction(this.state.updateInst,groupName)
  }

  addDocument = () => {
    let documents = this.state.updateInst.documents;
    if(_.isEmpty(documents)) {
      documents = []
    }
    let emptyDocument = {
      name: '',
      url: '',
    }
    let newDocuments = _.slice(documents);
    newDocuments.push(emptyDocument);
    
    this.setState({updateInst:{...this.state.updateInst, documents: newDocuments}});
  }

  updateDocument = (idx, originalDocument, updatedValue) => {
    let newDocument = _.assign({}, originalDocument, updatedValue);
    let updateDocs = this.state.updateInst.documents;
    updateDocs[idx] = newDocument;
    this.setState({updateInst:{...this.state.updateInst, documents: updateDocs}});
  }

  removeDocument = (idx) => {
    let documents = this.state.updateInst.documents;
    let filteredDocs = documents.filter((doc, i) => i !== idx)
    this.setState({updateInst:{...this.state.updateInst, documents: filteredDocs}});
  }

  updateVideo = () => {
    if( this.state.updateInst.videoUrl){
      delete this.state.updateInst.videoUrl
      this.setState({attachments:{...this.state.attachments, videoAdded: false}})
    }else{
      this.setState({
        attachments:{...this.state.attachments, videoAdded: true},
        updateInst:{...this.state.updateInst, videoUrl:''}
      })
    }
  }


  handleNewRequest = (chosenRequest, index) => {
    if( index > -1){
      this.setState({groupName: chosenRequest})
    }
  }

  updateImage = () => {
    if( this.state.updateInst.imageUrl){
      delete this.state.updateInst.imageUrl
      this.setState({attachments:{...this.state.attachments, imageAdded: false}})
    }else{
      this.setState({
        attachments:{...this.state.attachments, imageAdded: true},
        updateInst:{...this.state.updateInst, imageUrl:''}
      })
    }
  }

  handleUpdateInput = (searchText) => {
    this.setState({
      searchText: searchText,
    });
  };

  editInstrucition = () =>{
    // const rawData = markdownToDraft(description);
    // const contentState = convertFromRaw(rawData);

    this.setState({
        openEdit: true,
        updateInst: {...this.state.category},
        groupName: this.props.groupName,
        searchText: this.props.groupName,
        editorState: (this.props.category.categoryDescWithFormat)? RichTextEditor.createValueFromString(this.getDescription(this.props.category.categoryDesc,this.props.category.categoryDescWithFormat),'html'):
        RichTextEditor.createValueFromString('<p>' + this.props.category.categoryDesc + '</p>','html'),
       })
  }

  getDescription = (description, descriptionFomated) => {
    if ( descriptionFomated ){
      if( descriptionFomated[0] === '{'){
        
        let temp = JSON.parse(descriptionFomated);
        let descriptionFree = temp.blocks.map( block => block.text + '\n').join('\n');
        return '<p>'+ descriptionFree +'</p>'
     }else{

        let temp = RichTextEditor.createValueFromString(descriptionFomated,'html')
        return temp.toString('html', {blockStyleFn: getTextAlignStyles})
      }
    }else {
      let temp = RichTextEditor.createValueFromString('<p>' + description + '</p>','html')
      return temp.toString('html', {blockStyleFn: getTextAlignStyles})
    }
  }

  onEditorStateChange = (editorState) => {
    this.setState({
      editorState,
    });
    const contentState = editorState.getCurrentContent();
    let html = stateToHTML(contentState);
    let description = convertToRaw(contentState).blocks.map( block => block.text + '\n').join('\n');
    this.setState({updateInst:{...this.state.updateInst, categoryDesc: description, categoryDescWithFormat: html }})
  };

  onChange = (value) => {
    this.setState({editorState:value});
    let editorState = this.state.editorState.getEditorState();
    let contentState = editorState.getCurrentContent();
    this.setState({updateInst:{...this.state.updateInst, categoryDesc: contentState.getPlainText(), categoryDescWithFormat: value.toString('html', {blockStyleFn: getTextAlignStyles}) }})
  };


  render() {
    const toolbarConfig = {
      display: ['INLINE_STYLE_BUTTONS', 'BLOCK_TYPE_BUTTONS', 'BLOCK_TYPE_DROPDOWN','LINK_BUTTONS'],
      INLINE_STYLE_BUTTONS: [
        {label: 'Bold', style: 'BOLD', className: 'custom-css-class'},
        {label: 'Italic', style: 'ITALIC'},
        {label: 'Underline', style: 'UNDERLINE'}
      ],
      BLOCK_TYPE_DROPDOWN: [
        {label: 'Normal', style: 'unstyled'},
        {label: 'Heading Large', style: 'header-one'},
        {label: 'Heading Medium', style: 'header-two'},
        {label: 'Heading Small', style: 'header-three'}
      ],
      BLOCK_TYPE_BUTTONS: [
        {label: 'UL', style: 'unordered-list-item'},
        {label: 'OL', style: 'ordered-list-item'}
      ]
    };
    const {
      children,
    } = this.props;
    const actions = [
      <FlatButton
        label="Cancel"
        primary={true}
        style={ style.marginRight }
        onClick={this.handleClose}
      />,
      <RaisedButton 
        primary={true}
        label='Edit Instruction' 
        icon={<IconAdd/>} 
        onClick={this.upadteInstruction} 
      />
    ];
    let dataSourceConfig = {
      text: 'textKey',
      value: 'valueKey',
    };
    return (
      <div>
        <div className={'instruction'}>
          <div className={'instruction-left'}>
            <div className={'instruction-header'}>
              <h3 style={ style.instructionHeader}>{this.state.category.categoryName}</h3>
              <div  className={'instruction-icons'}>
                <IconPrint onClick={() => this.props.printInstruction(this.state.category)} style={style.print} />
                <IconEdit onClick={() => this.editInstrucition()} style={ style.edit }/>
                <IconDelete style={ style.delete } onClick={() => this.props.deleteInstruction()}/>                    
              </div>
            </div>
                <div dangerouslySetInnerHTML={{__html: this.getDescription(this.state.category.categoryDesc, this.state.category.categoryDescWithFormat)}} />
            <div className={'instruction-detail'}>
              <div style={style.labelContainer}>
                  <label style={style.label}>Content: </label>
                  <p style={{alignContent:'center'}}>
                  {this.state.category.videoUrl && <IconVideo />}
                  {this.state.category.imageUrl && <IconImage/>}
                  {this.state.category.documents && this.state.category.documents.length > 0 && <IconAttachment/>}
                  {this.state.category.youtubeVideo && <img src={youTubeLogo} alt='youTube logo'/>}
                  {this.state.category.wistiaVideo && <img src={wistiaLogo} alt='wistia logo'/>}
                  {!(this.state.category.videoUrl || this.state.category.imageUrl || this.state.category.youtubeVideo || this.state.category.wistiaVideo || (this.state.category.documents && this.state.category.documents.length) > 0 ) && "-"}
                  </p>
                <Dialog
                    actions={actions}
                    modal={true}
                    open={this.state.openEdit}
                    autoScrollBodyContent={true}
                    autoDetectWindowHeight={true}
                    actionsContainerClassName={"dialog-btns"}
                  >
                      <Title text1='Edit' text2='Instruction' goBack={this.handleClose}/>
                      <div className={'ins-counters'}>
                        <div className={'ins-counters-item'}>
                          <label style={style.insLabel}>Category:</label>

                          <AutoComplete
                            filter={AutoComplete.noFilter}
                            openOnFocus={true}
                            dataSource={this.props.allCategories}
                            onUpdateInput={this.handleUpdateInput}
                            dataSourceConfig={dataSourceConfig}
                            onNewRequest={this.handleNewRequest}
                            searchText={this.state.searchText}
                            hintText="Type or select the category name"
                            fullWidth={true}
                            menuStyle={{ maxHeight: 200 }}
                          />
                        </div>
                        <div className={'ins-counters-item'}>
                          <label style={style.insLabel}>Name:</label>
                          <input 
                            value={this.state.updateInst.categoryName }
                            onChange={ event => this.setState({updateInst:{...this.state.updateInst, categoryName: event.target.value}})}
                          />
                        </div>
                        <div className={'ins-counters-item'}>
                          <label style={style.insLabel}>Description:</label>
                          <RichTextEditor
                            value={this.state.editorState}
                            onChange={this.onChange}
                            className="wrapper-class-editer"
                            editorClassName="editor-class"
                            toolbarClassName="toolbar-class"
                            blockStyleFn={getTextAlignClassName}
                            toolbarConfig={toolbarConfig}
                          />
                        </div>
                      </div>
                      <div className={'newAttachments'}>    
                          <div className={'newAttachments-video'}>
                            <FloatingActionButton className={'newAttachments-video-btn'} onClick={() => this.updateVideo()} >
                              { this.state.attachments.videoAdded && <IconClear/>}
                              { !this.state.attachments.videoAdded && <IconVideo/>}
                            </FloatingActionButton>
                            { this.state.attachments.videoAdded && (
                              <div className={'newAttachments-video-uploader'}>
                                    <VideoPicker
                                      videoType="library"
                                      hidden={this.state.attachments.videoAdded}
                                      videoUrl={this.state.updateInst.videoUrl}
                                      userId={this.props.userId}
                                      appId={this.props.appId}
                                      previewStyle={style.media}
                                      handleSubmit={(videoUrl)=> this.setState({updateInst:{...this.state.updateInst, videoUrl: videoUrl}})}
                                    />
                              </div>
                            )}

                          </div>                     
                          <div className={'newAttachments-image'}>
                            <FloatingActionButton className={'newAttachments-image-btn'} onClick={() => this.updateImage()} >
                              { this.state.attachments.imageAdded && <IconClear/>}
                              { !this.state.attachments.imageAdded && <IconImage/>}
                            </FloatingActionButton>
                            { this.state.attachments.imageAdded && (
                              <div className={'newAttachments-image-uploader'}>
                                <ImagePicker
                                  key={this.state.updateInst.imageUrl}
                                  imageUrl={this.state.updateInst.imageUrl}
                                  userId={this.props.userId}
                                  previewStyle={style.media}
                                  hidden={this.state.attachments.imageAdded}
                                  handleSubmit={(imageUrl)=> this.setState({updateInst:{...this.state.updateInst, imageUrl: imageUrl}})}
                                />
                              </div>
                            )}

                          </div>         
                      </div>
                      <div style={ style.newAttachments }>
                      <div style={{display:'flex', flexDirection:'column', borderTop: "solid 1px", width:'100%', padding:10}}>
                            <div style={style.insLabel}>Documents:</div>
                            <NormalFlatButton
                            icon={<IconAdd color={colors.primary} />}
                            label='Add Additional Document'
                            onClick={()=>this.addDocument()} />
                          {this.state.updateInst.documents && this.state.updateInst.documents.map((document, idx) => {
                            return (
                              <div>
                                <div style={{display: 'inline-block'}}>
                                  <TextField
                                    floatingLabelText="Document Name"
                                    errorText={_.isEmpty(document.name) ? "This field is required" : ""}
                                    value={document.name}
                                    onChange={(event)=>{
                                      let name = event.target.value;
                                      this.updateDocument(idx, document, {name});
                                    }}/>
                                </div>
                                {!_.isEmpty(document.url) &&
                                  <a href={document.url} target="_blank" alt={"Download " + document.name}>Download</a>
                                }
                                <div style={{display: 'inline-block'}}>
                                  <FilePicker
                                    fileUrl={document.url}
                                    userId={this.props.userId}
                                    appId={this.props.appId}
                                    handleSubmit={(fileUrl)=>{
                                      this.updateDocument(idx, document, {url: fileUrl});
                                    }}
                                  />
                                </div>
                                <div style={{display: 'inline-block'}}>
                                  <DeleteButton onClick={()=> this.removeDocument(idx)}/>
                                </div>
                              </div>
                            )})}
                        </div>
                      </div>
                      <div className={'attachments-thumbnail'}>                  



                        
                      </div>
                      <div className={'ins-counters'}>
                        <div className={'ins-counters-item'}>
                          <label style={style.insLabel}>YouTube Video:</label>
                          <input 
                            placeholder="YouTube Video URL"
                            value={this.state.updateInst.youtubeVideo && this.state.updateInst.youtubeVideo.url}
                            onChange={ event => this.setState({updateInst:{...this.state.updateInst, youtubeVideo: {url:event.target.value, id:UrlUtils.getYoutubeVideoId(event.target.value)}}})}
                          />
                        </div>
                        <div className={'ins-counters-item'}>
                          <label style={style.insLabel}>Wistia Video:</label>
                          <input 
                            placeholder="Wistia Video URL"
                            value={this.state.updateInst.wistiaVideo && this.state.updateInst.wistiaVideo.url}
                            onChange={ event => this.setState({updateInst:{...this.state.updateInst, wistiaVideo: {url:event.target.value, id:UrlUtils.getWistiaVideoId(event.target.value)}}})}
                          />
                        </div>
                      </div>
                    {this.props.showAllFields && (
                      <div className={'ins-counters'}>
                        <div className={'ins-counters-item'}>
                          <label style={style.insLabel}>Repetitions:</label>
                          <input 
                            placeholder="Default Number Of Repetitions"
                            value={this.state.updateInst.defaultReps}
                            onChange={ event => this.setState({updateInst:{...this.state.updateInst, defaultReps: event.target.value}})}
                          />
                        </div> 
                        <div className={'ins-counters-item'}>
                        <label style={style.insLabel}>Sets:</label>
                        <input 
                          placeholder="Default Number Of Sets"
                          value={this.state.updateInst.defaultSets}
                          onChange={ event => this.setState({updateInst:{...this.state.updateInst, defaultSets: event.target.value}})}
                        />
                        </div>
                        <div className={'ins-counters-item'}>
                          <label style={style.insLabel}>Duration:</label>
                          <input 
                            placeholder="Default Duration"
                            value={this.state.updateInst.defaultDuration}
                            onChange={ event => this.setState({updateInst:{...this.state.updateInst, defaultDuration: event.target.value}})}
                          />
                        </div>
                        <div className={'ins-counters-item'}>
                          <label style={style.insLabel}>Intensity:</label>
                          <input 
                            placeholder="Default Intensity"
                            value={this.state.updateInst.defaultIntensity}
                            onChange={ event => this.setState({updateInst:{...this.state.updateInst, defaultIntensity: event.target.value}})}
                          />
                        </div>
                        <div className={'ins-counters-item'}>
                          <label style={style.insLabel}>Frequency:</label>
                          <input 
                            placeholder="Default Frequency"
                            value={this.state.updateInst.defaultFrequency}
                            onChange={ event => this.setState({updateInst:{...this.state.updateInst, defaultFrequency: event.target.value}})}
                          />
                        </div>
                      </div>
                      )}
                  </Dialog>
              </div>
            </div>
            {(this.state.category.defaultSets || this.state.category.defaultSets || this.state.category.defaultDuration
              || this.state.category.defaultIntensity || this.state.category.defaultFrequency) && <h4 style={{borderBottom:'solid', borderBottomWidth:1, margin:5, color:colors.primary}}>Defaults</h4>}
            <div className={'instruction-detail'}>
              {this.state.category.defaultReps && <div style={style.labelContainer}><p><label style={style.label}>Reps:</label>{this.state.category.defaultReps}</p></div>}
              {this.state.category.defaultSets && <div style={style.labelContainer}><p><label style={style.label}>Sets:</label>{this.state.category.defaultSets}</p></div>}
              {this.state.category.defaultDuration && <div style={style.labelContainer}><p><label style={style.label}>Duration:</label>{this.state.category.defaultDuration}</p></div>}
              {this.state.category.defaultIntensity && <div style={style.labelContainer}><p><label style={style.label}>Intensity:</label>{this.state.category.defaultIntensity}</p></div>}
              {this.state.category.defaultFrequency && <div style={style.labelContainer}><p><label style={style.label}>Frequency:</label>{this.state.category.defaultFrequency}</p></div>}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default InstructionLibrary;



// WEBPACK FOOTER //
// ./src/layout/playbook/library/InstructionLibrary.js